import { onDomReady } from '../../components/dynamic/observer';

class Header {
  constructor(selector) {
    this.header = selector;
    this.headerHeight = this.header.offsetHeight;
    this.headerContainer = this.header.querySelector('[data-header-container]');
    this.headerInner = this.header.querySelector('[data-header-inner]');
    this.dropMenu = selector.querySelector('[data-drop-menu]');

    this.hamburger = selector.querySelector('[data-hamburger]');

    this.isOpened = false;

    this.eventListeners();
  }

  open() {
    this.isOpened = true;
    this.header.classList.add('_opened');
    this.dropMenu.classList.add('_opened');
    this.hamburger.classList.add('_opened');
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
  }

  close() {
    this.isOpened = false;
    this.header.classList.remove('_opened');
    this.dropMenu.classList.remove('_opened');
    this.hamburger.classList.remove('_opened');
    document.body.style.overflow = '';
    document.body.style.height = '';
  }

  addSticky() {
    const instance = this;
    // если проскролили ниже высоты хедера
    if (instance.scrollTop > instance.headerHeight) {
      instance.header.classList.add('_sticky');
    } else {
      instance.header.classList.remove('_sticky');
    }

    if (instance.scrollTop > 0) {
      instance.headerContainer.classList.add('_sticky');
    } else {
      instance.headerContainer.classList.remove('_sticky');
    }
  }

  handleHeader() {
    const instance = this;

    if (instance.scrollTop < instance.lastScrollTop) { // up
      if (instance.scrollTop > instance.headerHeight) {
        // скролтоп ниже высоты шапки
        instance.header.classList.add('_up');
        instance.headerContainer.style.transform = 'translate3d(0, 0, 0)';
        document.dispatchEvent(new Event('header-up'));
      }

      if (instance.scrollTop <= instance.headerHeight) {
        // скролтоп в зоне высоты шапки
        if (!instance.header.classList.contains('_up')) {
          instance.headerContainer.style.transform = `translate3d(0, -${instance.scrollTop}px, 0)`;
        }
      }

      if (instance.scrollTop <= 0) {
        instance.header.classList.remove('_up');
        instance.headerContainer.style.transform = '';
        instance.headerContainer.style.transition = '';
      }

    } else { // down
      instance.header.classList.remove('_up');
      document.dispatchEvent(new Event('header-down'));

      if (instance.scrollTop <= instance.headerHeight) {
        // скролтоп в зоне высоты шапки
        instance.headerContainer.style.transform = `translate3d(0, -${instance.scrollTop}px, 0)`;
        instance.headerContainer.style.transition = '';
      } else {
        // скролтоп ниже высоты шапки
        instance.headerContainer.style.transform = 'translate3d(0, -100%, 0)';
        instance.headerContainer.style.transition = 'transform .4s ease-in-out';
      }
    }
  }

  eventListeners() {
    if (this.hamburger) {
      this.hamburger.addEventListener('click', () => {
        this.isOpened ? this.close() : this.open();
      });
    }

    document.addEventListener('click', (e) => {
      if (this.isOpened && this.dropMenu === e.target) {
        this.close();
      }
    });

    window.addEventListener('scroll', () => {
      const instance = this;
      instance.scrollTop = window.scrollY;

      instance.addSticky();

      instance.handleHeader();

      instance.lastScrollTop = instance.scrollTop;
    });
  }
}

onDomReady(() => {
  const headerSelector = document.querySelector('[data-header]');
  if (headerSelector) {
    new Header(headerSelector);
  }
});